export const footerItems = {
  column1: [
    { label: "Corporates", path: "/corporates" },
    { label: "Forex Consultants", path: "/forex-consultants" },
    { label: "Banks", path: "/banks" },
     { label: "NBFCs", path: "/nbfcs" },
  ],
  column2: [
    { label: "LinkedIn", url: "https://www.linkedin.com/company/finvisagebyapexft" },
  ],
  column3: [
    { label: "Pitch Deck",link_label:"Footer_terms_link", url: "https://finvisageimages-india.s3.ap-south-1.amazonaws.com/Finvisage_Pitch_Deck.pdf" },
    { label: "Terms & Conditions",link_label:"Footer_terms_link", url: "https://finvisageimages-india.s3.ap-south-1.amazonaws.com/Finvisage_Terms_and_Conditions.pdf" },
    { label: "Privacy Policy",link_label:"Footer_privacy_link", url: "https://finvisageimages-india.s3.ap-south-1.amazonaws.com/Finvisage_privacy_policy.pdf" },
    { label: "Refund Policy",link_label:"Footer_refund_link", url: "https://finvisageimages-india.s3.ap-south-1.amazonaws.com/Finvisage_Refund_Policy.pdf" },
    { label: "YouTube",link_label:"Footer_Youtube_link", url: "https://www.youtube.com/@finvisagebyapexfinancialte1656" },
  ],
};

export const HeaderItems = {
  column1: [
    { label: "Corporates",link_label:"Header_Corporates_link", path: "/corporates" },
    { label: "Forex Consultants",link_label:"Header_fx_link", path: "/forex-consultants" },
    { label: "Banks",link_label:"Header_banks_link", path: "/banks" },
    { label: "NBFCs",link_label:"Header_banks_link", path: "/nbfcs" },
  ],
};

export const pricingitems = [
  {
    imgSrc: "/image/rightTick.webp",
    text: "Create and set up your workspace in two minutes.",
  },
  {
    imgSrc: "/image/rightTick.webp",
    text: "Add credits to your account from anywhere in the world.",
  },
  {
    imgSrc: "/image/rightTick.webp",
    text: "Add the derivative structures of your choice & start pricing.",
  },
  {
    imgSrc: "/image/rightTick.webp",
    text: "Forwards, Options, IRS & CCS Swaps are available.",
  },
  {
    imgSrc: "/image/rightTick.webp",
    text: "No fixed-term contracts. Pay as you use.",
  },
];




  export const CorporateHomePageData = {
    imgSrc: "/image/transparentLogo.webp",
    service: "For Corporates",
    imgSrc2: "/image/corporateCarousal.webp",
    texts: [
      "Do your imports & exports have an FX risk? ",
      "Would you like to know the fair price of your FX derivative deals? ",
      "Are you interested in knowing the value of IRS and CCS contracts before dealing? ",
      // "What if you could use a pricer without signing up for an expensive, long-term contract with a terminal provider?",
      "Step into financial clarity with us.",
     
    ],
  };

  export const ForexConsultantsHomePageData = {
    imgSrc: "/image/transparentLogo.webp",
    service: "For FX Consultants",
    imgSrc2: "/image/fxConsultantCarousal.webp",
   
    texts: [
      "Ready to stand out in a crowded field?",
      "Looking to gain a competitive edge with your clients? ",
      "Would you like to be the consultant of choice to clients?",
      "Your blueprint for customer delight.",
     
    ],
  };
  export const BanksHomePageData = {
    imgSrc: "/image/transparentLogo.webp",
    service: "For Banks",
    imgSrc2: "/image/bankCarousal.webp",
   
    texts: [
      "Do you want to empower your treasury sales teams with individual derivative pricers? ",
      "Looking to boost your team's hit ratio?",
      "Would you like to lower your costs of expensive market terminals? ",
      "Your derivatives solutions, simplified.",
    ],
  };

  export const NBFCsHomePageData = {
    imgSrc: "/image/transparentLogo.webp",
    service: "For NBFCs",
    imgSrc2: "/image/Nbfcs_homepage.webp",
    texts: [
      "Are your liabilities scattered across multiple Excel files and manual trackers?",
      "Do you spend excessive time on schedules, interest calculations, and pool creation?",
      "Looking for a single system to track liabilities, repayments, and covenants accurately?",
      "Transform the way you manage your liabilities.",
    ],
   
  };

    export const testimonialsData = [
    {
      quote:'Banks have been built around compliance, and Fintechs are built around convenience. So, while we have seen a lot of successful Fintech companies, findings indicate that till about 2017-18, Fintechs have been more active in the retail and payments space. This decade is, however, seeing the growing influence of Fintech in the Corporate Wholesale Banking space, including Trade, Treasury, and Investment Banking. Banks and Fintechs will have to collaborate as a team to work for Corporate Treasuries to solve their problems together. Finvisage, both the product and team are known to me and I can endorse both. They are destined for bigger things soon. More power to you guys. Cheers.',
  
      name: 'Brejesh Chalill',
      position: 'Head of Treasury Markets Sales',
      company: 'Axis Bank',
    },
   
    {
      quote:'As the CEO of Cogencis, ensuring our clients have access to accurate, robust financial tools is essential to our success. Finvisage’s Derivative Pricer has been an invaluable addition to our terminal, delivering precise and fast pricing solutions that our clients can rely on. Its integration into our platform has been seamless, and we have received consistently positive feedback from users who rely on its accuracy in dynamic market conditions. Finvisage has proven to be a trusted partner, helping us elevate our product offering, and we are thrilled with the impact it has had on our clients decision-making and trading efficiency.',
      name: 'Aniruddha Chatterjee',
      position: 'Managing Director & CEO',
      company: 'NSE Cogencis',
    },
    {
      quote:'Arshdeep Jindal, Vishal Kapadia & Jayanth Ravindran, the trio are a lethal combination. The best thing about the team is that they always talk about the solution to a problem rather than the problem itself. Finvisage is a fantastic derivatives pricing tool that can cater to all segments of corporate treasury in India and abroad.',
      name: 'Akhilesh Dubey',
      position: 'Assistant Vice President Derivatives Structuring & Sales',
      company: 'Axis Bank',
    },
    {
      quote:'I would very much recommend that other companies consider utilising this system within their own business and look forward to continuing our relationship working together.',
      name: 'Tom Mitten',
      position: 'Statutory reporting and treasury manager',
      company: 'Nichols PLC UK',
    },
    {
      quote:'Finvisage’s BALM platform has transformed how we manage our liability book. What used to take us days of manual reconciliation, data gathering, and spreadsheet work is now available in a single, clean, real-time interface. The accuracy, transparency, and depth of insights BALM provides have helped our treasury team make faster, more confident decisions. For Fusion Finance, BALM has become a core part of our treasury workflow. It is not just a reporting tool, but a decision-support system. The implementation was seamless, and the Finvisage team has been a truly collaborative partner throughout and on an ongoing basis. We now have complete visibility across maturities, interest rate profiles, and risk exposures, enabling us to run our business with greater clarity and control. Finvisage delivers exactly what modern NBFCs need.',
      name: 'Sanjay Mahajan',
      position: 'Chief Information Officer',
      company: ' FUSION FINANCE',
    },
  
   
  ];


  export const scrollTop = () => {
   
    try {
      document.documentElement.scroll({
        top: 0,
        behavior: "smooth",
      });
    } catch (e) {
      document.body.scroll({
        top: 0,
        behavior: "smooth",
      });
    }
  };
  